export const SCREEN_RESIZE = "screen/resize";
